'use client';

import React from 'react';

interface ChipViewProps {
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
  variant?: 'default' | 'selected';
  className?: string;
}

const ChipView: React.FC<ChipViewProps> = ({
  label,
  isSelected = false,
  onClick,
  variant = 'default',
  className = ""
}) => {
  const getVariantStyles = () => {
    if (isSelected || variant === 'selected') {
      return 'bg-[#3D1C1A] text-[#FEF5E6] shadow-sm';
    }
    return 'bg-[#3D1C1A] bg-opacity-[0.35] text-[#FEF5E6]';
  };

  return (
    <div data-component-id="src/components/ui/ChipView.tsx:28:4" data-component-path="src/components/ui/ChipView.tsx" data-component-line="28" data-component-file="ChipView.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      onClick={onClick}
      className={`
        flex items-center justify-center
        px-7 md:px-9 py-[0.3rem] rounded-md
        font-tt-norms-bold text-[18px] text-center
        cursor-pointer transition-all duration-150
        hover:opacity-90
        ${getVariantStyles()}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {label}
    </div>
  );
};

export default ChipView;